import m from "../../es2015/lang/en_US";
window.am4lang_en_US = m;


//////////////////
// WEBPACK FOOTER
// ./lang/en_US.js
// module id = null
// module chunks = 